module.exports = __webpack_public_path__ + "assets/img/bxzy.be72eeb6.png";